import React, {Component} from 'react'
// import * as firebase from 'firebase'

import LandingPageHeader from '../components/LandingPageHeader'
import LandingPageLearnMore from '../components/LandingPageLearnMore'
import LandingPageDemo from '../components/LandingPageDemo'
import LandingPageSpacer from '../components/LandingPageSpacer'
import LandingPageContact from '../components/LandingPageContact'
// import Footer from '../components/Footer'

// import {bgWhite} from '../helper/consts'

const style = {
  landingPage:{
    // backgroundColor:bgWhite,
    maxWidth: '100vw',
  },
}

export default class LandingPage extends Component{
  render(){
    return (
      <div style={style.landingPage}>
        <LandingPageHeader />
        <LandingPageSpacer flip={true} />
        <LandingPageLearnMore />
        <LandingPageSpacer />
        <LandingPageDemo />
        <LandingPageSpacer flip={true} />
        <LandingPageContact />
        <LandingPageSpacer />
      </div>
    )
  }
}
// <Footer />



// WEBPACK FOOTER //
// ./src/pages/LandingPage.js